import axios from 'axios';
import { useState } from 'react';
import { SUMMARY_API_URL } from '../utils/apiUrls';
import { getAccessToken } from '../utils/token-service';

const useCommonApiCall = () => {
	const [loading, setLoading] = useState(false);
	const [responseData, setResponseData] = useState(null);

	const callApi = async (promptValue: any, messageValue: any) => {
		const accessToken = await getAccessToken();
		setLoading(true);

		let config = {
			method: 'post',
			maxBodyLength: Infinity,
			url: SUMMARY_API_URL,
			headers: {
				'Content-Type': 'application/json',
				Authorization: `Bearer ${accessToken}`,
			},
			data: {
				prompt: promptValue,
				message: messageValue,
			},
		};

		try {
			const response = await axios.request(config);
			setResponseData(response.data.output);
		} catch (error) {
			console.log('Error calling API:', error);
		} finally {
			setLoading(false);
		}
	};

	return { loading, responseData, callApi };
};
export default useCommonApiCall;
